import { render } from "./DuihuanRecord.vue?vue&type=template&id=7d347ace&scoped=true"
import script from "./DuihuanRecord.vue?vue&type=script&lang=js"
export * from "./DuihuanRecord.vue?vue&type=script&lang=js"

import "./DuihuanRecord.vue?vue&type=style&index=0&id=7d347ace&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d347ace"]])

export default __exports__